export const swapMapKeyVal = <T1, T2>(map: Map<T1, T2>) => {
  const returnMap = new Map<T2, T1>();
  map.forEach((value, key) => {
    returnMap.set(value, key);
  });
  return returnMap;
};
